import { Pushable, pushableEventOfPure } from "./pushable";
import { OpenDealerLocator, SearchDealerLocator } from "./GoogleTagManagerIntegration";
import { ProductVariantAvailabilityStatus } from "@swo/shared";

export const dealerLocatorTrackingAspect = {
  openDealerLocator: (sku: string, availability: ProductVariantAvailabilityStatus["tag"]): Pushable => {
    return pushableEventOfPure({
      event: "open-dealer-locator",
      id: sku,
      availability: availability,
    });
  },
  searchDealerLocator: (): Pushable => {
    return pushableEventOfPure({
      event: "search-dealer-locator",
    });
  },
};
